import { motion } from "framer-motion";

// Masked line-by-line reveal. Each line sits in an overflow-hidden wrapper
// and translates up from 100% to 0% with a staggered spring ease.
export const MaskedReveal = ({ lines = [], className = "", delay = 0, as = "h1", testid }) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag className={className} data-testid={testid} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1,
              delay: delay + i * 0.11,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export default MaskedReveal;
